<app-table-header
  [tableName]="tableName()"
  [activeMode]="currentMode()"
  [selectedItems]="selectedItemsCount()"
  [selectedRecords]="selectedRowsData()"
  [actions]="actions()"
  [subtitleTemplate]="subtitleTemplate"
  [actionsTemplate]="actionsTemplate"
  [canCreate]="canCreate()"
  [canEdit]="canEdit()"
  [canDelete]="canDelete()"
  [disableDuplicate]="disableDuplicate()"
  (createRecord)="onCreateRecord()"
  (deleteRecord)="onDeleteRecord()"
  (duplicateRecord)="onDuplicateRecord()"
  (summaryRecord)="onSummaryRecord()"
  (saveRecord)="onSaveRecord()"
  (cancelRecord)="onCancelRecord()"
>
  <ng-content select="[table-header-subtitle]"></ng-content>
</app-table-header>

<app-generic-table
  #gridTable
  [entityColumnDefinitions]="columnDefinitions()"
  [extraOptions]="extraTableOptions()"
  [dataSource]="combinedDataset()"
  [loading]="loading()"
  [exportInProgress]="exportInProgress()"
  [canEditInline]="canEditInline()"
  [canEdit]="canEdit()"
  [showEditColumn]="showEditColumn()"
  [rowActionConfig]="rowActionConfig()"
  [rowsWithErrors]="rowsWithErrors"
  [backendServiceProcess]="backendServiceProcess"
  (rowAction)="onRowAction($event)"
  (editRow)="onEditRow($event)"
  (selectedItemsChange)="onRowSelectionChange($event)"
  (beforeEditCell)="onBeforeEditCell($event)"
  (destroyEditor)="onCellEdited($event)"
  (cellChange)="onCellChange($event)"
  (triggerEditMode)="onTriggerEditMode($event)"
  (initializationCompleted)="onGridReady($event)"
  (exportToExcelRecord)="onExportToExcelRecord()"
  (technicalNamesReport)="onTechnicalNamesReport()"
></app-generic-table>

<app-technical-names-report-modal
  [(isVisible)]="isTechnicalNamesModalOpen"
  [config]="modalConfig()">
</app-technical-names-report-modal>

@if (hasPrefilters() && showPrefilters()) {
  <app-pre-access-filter-modal
    [fields]="prefilterFields()"
    [tableName]="tableName()"
    [appliedFilters]="preAccessFiltersState()"
    [(isVisible)]="isPreAccessModalVisible"
    (filtersApplied)="onPreAccessFiltersApplied($event)"
    (filtersClosed)="onPreAccessFiltersClosed()"
  />
}
